export default class GenericMethods {
    constructor($http) {
        return {
            retrieveLocalFile(directory, fileName) {
                var browserRootDir = '/../../assets/';
                // Example: /../../assets/data/advindaCountryList.json
                return $http.get(browserRootDir + directory + fileName);
            },
        };
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/services/genericMethods.js
 **/